// Visitor source attribution. Navigation data only: no IP, no geolocation,
// no fingerprint, no marketing cookie. Stored in sessionStorage for the session only.

const KEY = "cs_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const readSession = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};

// Runs once per session, on the very first page load: that page is the landing page.
export const captureLanding = () => {
  if (typeof window === "undefined" || readSession()) return;
  const params = new URLSearchParams(window.location.search);
  const captured = { landing_page: window.location.pathname };
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) captured[key] = value.slice(0, 200);
  });
  if (document.referrer) captured.referrer = document.referrer.slice(0, 300);
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(captured));
  } catch {
    /* private mode: attribution is simply skipped */
  }
};

export const getAttribution = () => ({
  ...(readSession() || {}),
  source_page: typeof window !== "undefined" ? window.location.pathname : undefined,
});
